"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotifyCumulus = void 0;
var _mui = require("@ori-ui/mui");
var _react = _interopRequireWildcard(require("react"));
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _Loading = require("../Loading");
var _NotifyForm = require("../NotifyForm");
var _NotifyType = require("../NotifyType");
var _RequestFailed = require("../RequestFailed");
var _Thanks = require("../Thanks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const NotifyCumulus = () => {
  const {
    config,
    productCode,
    successClose
  } = (0, _contexts.useAppContext)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const [currentType, setCurrentType] = (0, _react.useState)(config?.isSmsChannelDefault ? _models.BackInStockNotificationChannel.Sms : _models.BackInStockNotificationChannel.Email);
  const [inputData, setInputData] = (0, _react.useState)('');
  const [isReserved, setIsReserved] = (0, _react.useState)(false);
  const {
    userData,
    loading,
    error
  } = (0, _hooks.useUserData)({
    currentType,
    setInputData
  });
  const isEmail = _models.BackInStockNotificationChannel.Email === currentType;
  (0, _react.useEffect)(() => {
    if (userData.email && currentType === _models.BackInStockNotificationChannel.Email) {
      setInputData(userData.email);
    } else if (userData.telephoneNumber && currentType === _models.BackInStockNotificationChannel.Sms) {
      setInputData(userData.telephoneNumber);
    }
  }, [currentType, userData.email, userData.telephoneNumber]);
  const onChangeData = (0, _react.useCallback)(event => {
    const trimmedValue = event.currentTarget.value.trim();
    setInputData(trimmedValue);
  }, []);
  const onChangeType = (0, _react.useCallback)(selectedType => {
    setCurrentType(selectedType);
  }, []);
  const label = (0, _react.useMemo)(() => isEmail ? translations.enterYourEmail : translations.enterTelephoneNumber, [isEmail, translations.enterTelephoneNumber, translations.enterYourEmail]);
  const onSubmit = (0, _react.useCallback)(() => {
    setIsReserved(true);
    successClose();
  }, [successClose]);
  if (loading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {});
  }
  if (error) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RequestFailed.RequestFailed, {})
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    isSmsEnabled: config?.smsSubscriptionEnabled,
    children: isReserved ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Thanks.Thanks, {
      currentType: currentType
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "h5",
        component: "h5",
        textAlign: "center",
        children: translations.notifyMe
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.InfoText, {
        children: label
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotifyType.NotifyType, {
        currentType: currentType,
        onChange: onChangeType
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotifyForm.NotifyForm, {
        currentType: currentType,
        inputData: inputData,
        productCode: productCode,
        onChange: onChangeData,
        onSubmit: onSubmit
      })]
    })
  });
};
exports.NotifyCumulus = NotifyCumulus;